/**
 * Do not edit directly
 * Generated on Tue, 24 Jan 2023 12:01:59 GMT
 */

export const sizeBorderRadiusX1 = "2px";
export const sizeBorderRadiusX2 = "4px";
export const sizeBorderRadiusX3 = "6px";
export const sizeBorderRadiusX4 = "8px";
export const sizeBorderRadiusX5 = "10px";
export const sizeBorderRadiusX6 = "12px";
export const sizeBorderRadiusX8 = "16px";
export const sizeBorderRadiusX10 = "20px";
export const sizeBorderRadiusX12 = "24px";
export const sizeBorderRadiusX15 = "30px";
export const sizeBorderRadiusCircle = "50%";
export const sizeBorderWidthRegular = "1px";
export const sizeControlHeightSmall = "40px";
export const sizeControlHeightMedium = "48px";
export const sizeControlHeightLarge = "56px";
export const sizeIconSmall = "18px";
export const sizeIconMedium = "20px";
export const sizeIconLarge = "24px";
export const sizeSpacingX1 = "4px";
export const sizeSpacingX2 = "8px";
export const sizeSpacingX3 = "12px";
export const sizeSpacingX4 = "16px";
export const sizeSpacingX5 = "20px";
export const sizeSpacingX6 = "24px";
export const sizeSpacingX7 = "28px";
export const sizeSpacingX8 = "32px";
export const sizeSpacingX9 = "36px";
export const sizeSpacingX10 = "40px";